<template>
    <StrideFooter v-if="theme === 'stride'" />
    <VentureFooter v-if="theme === 'venture'" />
    <OrbitFooter v-if="theme === 'orbit'" />
</template>

<script src="./footer.js" />
<style lang="scss" scoped src="./footer.scss" />
